module.exports = __webpack_public_path__ + "static/media/dragon.e89acfb3.svg";